<div class="wallet">

  <!-- ============ PAGE HEAD ============ -->
  <div class="pagehead">
    <div>
      <h1>Recharge wallet</h1>
      <p>Deposit into a listed bank account, then request the money into your wallet with the receipt</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Mode">
        <button type="button" [class.on]="receipt" (click)="assignType({ value: 'receipt' })">Request money</button>
        <button type="button" [class.on]="reqHistory" (click)="assignType({ value: 'reqHistory' })">Request history</button>
      </div>
    </div>
  </div>

  <!-- ============ REQUEST MONEY ============ -->
  <div class="row-2-1" *ngIf="receipt">
    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/></svg>Request details</div>

      <form [formGroup]="requestMoney" role="form" #form="ngForm" (ngSubmit)="form.valid && onSubmit(form.value)" class="req-form">

        <div class="form-grid">
          <div class="er-field er-field--amount"
            [class.has-error]="requestMoney.get('amount').invalid && (requestMoney.get('amount').touched || form.submitted)">
            <label class="er-field__label" for="rw-amount">Amount <span class="req">*</span></label>
            <div class="er-field__wrap">
              <span class="er-field__affix">₹</span>
              <input id="rw-amount" class="er-field__control" formControlName="amount" name="amount"
                placeholder="0" inputmode="numeric" autocomplete="off" (keypress)="numberOnly($event)">
            </div>
            <div class="er-field__help"
              *ngIf="!requestMoney.get('amount').hasError('maxValueExceeded') && !(requestMoney.hasError('required','amount') && (requestMoney.get('amount').touched || form.submitted))">Whole rupees only · up to ₹10,00,000</div>
            <div class="er-field__error" *ngIf="requestMoney.hasError('required','amount') && (requestMoney.get('amount').touched || form.submitted)">Enter the amount</div>
            <div class="er-field__error" *ngIf="requestMoney.hasError('maxValueExceeded','amount')">Amount can't exceed ₹10,00,000</div>
          </div>

          <div class="er-field"
            [class.has-error]="requestMoney.get('txnref').invalid && (requestMoney.get('txnref').touched || form.submitted)">
            <label class="er-field__label" for="rw-txnref">Transaction reference <span class="req">*</span></label>
            <div class="er-field__wrap">
              <input id="rw-txnref" class="er-field__control er-field__control--mono" formControlName="txnref" name="Remark"
                placeholder="UTR / reference number" autocomplete="off">
            </div>
            <div class="er-field__error" *ngIf="requestMoney.hasError('required','txnref') && (requestMoney.get('txnref').touched || form.submitted)">Enter the transaction reference</div>
          </div>

          <div class="er-field"
            [class.has-error]="requestMoney.get('bank').invalid && (requestMoney.get('bank').touched || form.submitted)">
            <label class="er-field__label" for="rw-bank">Your bank <span class="req">*</span></label>
            <select id="rw-bank" class="er-select" formControlName="bank">
              <option value="" disabled selected hidden>Select the bank you paid from</option>
              <option *ngFor="let subservice of bankDATA" [value]="subservice.iinno">{{ subservice.bankName }}</option>
            </select>
            <div class="er-field__error" *ngIf="requestMoney.hasError('required','bank') && (requestMoney.get('bank').touched || form.submitted)">Select your bank</div>
          </div>

          <div class="er-field"
            [class.has-error]="requestMoney.get('yourbank').invalid && (requestMoney.get('yourbank').touched || form.submitted)">
            <label class="er-field__label" for="rw-ymbank">Deposited to <span class="req">*</span></label>
            <select id="rw-ymbank" class="er-select" formControlName="yourbank">
              <option value="" disabled selected hidden>Select the listed account you paid into</option>
              <option *ngFor="let subservice of bankYMDATA" [value]="subservice.bankAccountNumber">{{ subservice.bankAccountNumber }} ({{ subservice.bankName }})</option>
            </select>
            <div class="er-field__error" *ngIf="requestMoney.hasError('required','yourbank') && (requestMoney.get('yourbank').touched || form.submitted)">Select the account you deposited into</div>
          </div>

          <div class="er-field span-2"
            [class.has-error]="requestMoney.get('remarks').invalid && (requestMoney.get('remarks').touched || form.submitted)">
            <label class="er-field__label" for="rw-remarks">Remarks <span class="req">*</span></label>
            <div class="er-field__wrap">
              <input id="rw-remarks" class="er-field__control" formControlName="remarks" name="remark"
                placeholder="Anything the approver should know" autocomplete="off">
            </div>
            <div class="er-field__error" *ngIf="requestMoney.hasError('required','remarks') && (requestMoney.get('remarks').touched || form.submitted)">Enter a remark</div>
          </div>

          <div class="er-field span-2">
            <label class="er-field__label">Deposit receipt <span class="req">*</span></label>
            <div class="er-dropzone" role="button" tabindex="0" (click)="triggerFile(fileInput17)"
              (keydown.enter)="triggerFile(fileInput17)">
              <div class="er-dropzone__icon">⇪</div>
              <ng-container *ngIf="!RecieptName">Upload the payment receipt</ng-container>
              <ng-container *ngIf="RecieptName"><span class="file-name">{{ RecieptName }}</span> — click to replace</ng-container>
              <div class="er-dropzone__hint">Image up to 5 MB</div>
            </div>
            <input id="custom-input" type="file" #fileInput17 (change)="uploadRecipt1($event)" style="display:none" accept="image/*">
            <div class="er-field__error" *ngIf="uploadRecipt">Receipt must be an image no larger than 5 MB</div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="er-btn er-btn--primary">Request money</button>
        </div>
      </form>
    </div>

    <div class="card">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M3 10l9-6 9 6M5 10v9h14v-9M9 19v-5h6v5"/></svg>Listed bank accounts</div>
      <p class="banks-hint">Deposit only into these accounts — requests against other accounts are rejected.</p>
      <div class="bank" *ngFor="let i of bankYMDATA">
        <div class="bank-name">{{ i.bankName }}</div>
        <div class="bank-row"><span class="bl">Account name</span><span class="bv">{{ i.accountHolderName }}</span></div>
        <div class="bank-row"><span class="bl">Account number</span><span class="bv bv--mono">{{ i.bankAccountNumber }}</span></div>
        <div class="bank-row"><span class="bl">Branch</span><span class="bv">{{ i.bankBranch }}</span></div>
        <div class="bank-row"><span class="bl">IFSC</span><span class="bv bv--mono">{{ i.ifscCode }}</span></div>
      </div>
      <p class="banks-hint" *ngIf="!bankYMDATA || !bankYMDATA.length">No accounts listed right now.</p>
    </div>
  </div>

  <!-- ============ REQUEST HISTORY ============ -->
  <div class="tbl-card" *ngIf="reqHistory">
    <div class="tbl-head">
      <h3>Wallet requests</h3>
      <div class="seg seg--sub" role="tablist" aria-label="Status">
        <button type="button" [class.on]="openReq" (click)="previousWalletRequestStatus({ value: 'openReq' })">Pending</button>
        <button type="button" [class.on]="closeReq" (click)="previousWalletRequestStatus({ value: 'closeReq' })">Settled</button>
        <button type="button" [class.on]="rejectReq" (click)="previousWalletRequestStatus({ value: 'rejectReq' })">Rejected</button>
      </div>
    </div>

    <div class="tbl-scroll" *ngIf="!wallet">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th class="r">Amount</th>
            <th>Bank</th>
            <th>Reference</th>
            <th>Status</th>
            <th>Receipt</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of WalletRechargeStatus; let i = index">
            <td><span class="time">{{ item?.createdDate | date: 'd MMM yy' }}</span></td>
            <td class="r"><span class="amt">{{ item?.amount | erInr }}</span></td>
            <td>{{ item?.customerBank }}</td>
            <td><span class="txn">{{ item?.transactionRefNumber }}</span></td>
            <td>
              <span class="pill" [class.pend]="openReq" [class.ok]="closeReq" [class.fail]="rejectReq">
                <i class="sd"></i>{{ openReq ? 'Pending' : (closeReq ? 'Settled' : 'Rejected') }}
              </span>
            </td>
            <td>
              <img [src]="imageUrl + item?.proof" alt="Uploaded receipt" class="receipt-thumb"
                (click)="openmodalforUserDeletion(item._id, blockModal, i)">
            </td>
            <td class="remark">{{ item?.retailerRemark }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tbl-empty-state" *ngIf="wallet">
      <p>No {{ openReq ? 'pending' : (closeReq ? 'settled' : 'rejected') }} requests found.</p>
    </div>
  </div>

</div>

<ng-template #blockModal let-modal>
  <div class="modal-header er-modal-head">
    <h4 class="modal-title" id="modal-basic-title">Uploaded receipt</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body receipt-modal-body">
    <img [src]="imageUrl + OpenImg" alt="Uploaded receipt" class="img-popup">
  </div>
</ng-template>


